import {Paper, Typography} from '@mui/material';
import {motion} from 'framer-motion';

export default function AboutMission() {
  return (
    <Paper component={motion.div} whileHover={{scale: 1.02}} elevation={3} sx={{p: 4, borderRadius: 4}}>
      <Typography variant="h3" component="h2" gutterBottom>
        Our Mission
      </Typography>
      <Typography variant="body1" paragraph>
        At Etsy Seller Tool, our mission is to empower Etsy sellers with innovative tools and resources that simplify
        their business operations, boost their productivity, and drive their success in the competitive e-commerce
        landscape.
      </Typography>
      <Typography variant="body1">
        We believe that by providing user-friendly, efficient, and powerful solutions, we can help Etsy sellers focus on
        what they do best: creating unique products and building meaningful connections with their customers.
      </Typography>
    </Paper>
  );
}
